import React from 'react';

import { useIsAccountExpired } from '../../../../hooks/useIsAccountExpired';
import { CustomTooltip } from '~components/Tooltip';

export const RERUN_DISABLED_EXPIRED_MESSAGE = 'Upgrade your plan to rerun diagnostics.';

type RerunPlanGateProps = {
  render: (rerunDisabled: boolean) => React.ReactNode;
};

/**
 * Plan gate shared by every diagnostics run/rerun button (PRE-3097): renders
 * the button disabled with an upgrade tooltip when the account's trial has
 * expired or its subscription is cancelled. The inner `pointer-events: none`
 * wrapper is required for the tooltip to work at all — browsers suppress
 * mouse events over a disabled button, so hover must land on the tooltip's
 * own span instead of the button.
 */
export default function RerunPlanGate({ render }: RerunPlanGateProps) {
  const isAccountExpired = useIsAccountExpired();
  const rerunAction = render(isAccountExpired);

  if (!isAccountExpired) {
    return <>{rerunAction}</>;
  }

  return (
    <CustomTooltip
      placement="top"
      message={RERUN_DISABLED_EXPIRED_MESSAGE}
      wrapperStyle={{ cursor: 'not-allowed' }}
    >
      <span style={{ pointerEvents: 'none' }}>{rerunAction}</span>
    </CustomTooltip>
  );
}
